import { trackingConfig as tracking } from './tracking.config';

const $header = $(".header");
const $main = $("#main");
const $footer = $("#footer");
const $navMenu = $(".nav-menu");
const $navSubMenu = $(".nav-submenu");
const $navPrimary = $("#row-nav-primary");
const $controls = $("button[aria-controls], a[aria-controls]", $header);
const dataLayer = (window.dataLayer = window.dataLayer || []);
const smallView = 768;

function isSubMenu(menu) {
  return menu.parents("nav").length;
}

$.each($controls, function createMenu() {
  $(this).on("click", e => {
    const action = $(this);
    const menu = $(`#${action.attr("aria-controls")}`);
    const $this = $(this);
    let link;

    if (menu.hasClass("is-open")) {
      if (isSubMenu(menu)) {
        menu.removeClass("is-open").attr("aria-expanded", "false");
        action.removeClass("is-active");
        $header.removeClass("is-expanded");
        if (window.innerWidth >= smallView) {
          $main.attr("style", null);
          $footer.css("transform", `translateY(0px)`);
          if ($(".nav-secondary")) {
            $(".nav-secondary").css("transform", `translateY(0px)`);
          }
          $('body').trigger('menu:closed');
        }
      } else {
        $header
          .removeClass("is-expanded")
          .find(".is-active")
          .removeClass("is-active")
          .end()
          .find(".is-open")
          .removeClass("is-open")
          .attr("aria-expanded", "false");
        if (window.innerWidth >= smallView) {
          $main.attr("style", null);
          $footer.css("transform", `translateY(0px)`);
          if ($(".nav-secondary")) {
            $(".nav-secondary").css("transform", `translateY(0px)`);
          }
          $('body').trigger('menu:closed');
        }
        resizeMenu();
      }
    } else {
      if (!isSubMenu(menu)) {
        $header
          .find(".is-active")
          .removeClass("is-active")
          .end()
          .find(".is-open")
          .removeClass("is-open")
          .attr("aria-expanded", "false");
        if (window.innerWidth >= smallView) {
          $main.attr("style", null);
          $footer.css("transform", `translateY(0px)`);
          if ($(".nav-secondary")) {
            $(".nav-secondary").css("transform", `translateY(0px)`);
          }
          $('body').trigger('menu:closed');
        }
        resizeMenu();
      } else {
        if (window.innerWidth >= smallView) {
          $header
            .find(".is-active")
            .removeClass("is-active")
            .end()
            .find(".is-open")
            .removeClass("is-open")
            .attr("aria-expanded", "false")
            .end();
          $main.css("marginTop", `${menu.outerHeight()}px`);
          $('body').trigger('menu:open', [menu.outerHeight()]);
          $footer.css("transform", `translateY(${menu.outerHeight()}px)`);
          if ($(".nav-secondary")) {
            $(".nav-secondary").css(
              "transform",
              `translateY(${menu.outerHeight()}px)`
            );
          }
        }
      }
      menu.addClass("is-open").attr("aria-expanded", "true");
      action.addClass("is-active");
      $header.addClass("is-expanded");

      if ($this.attr("href") === "#") {
        link = $this.attr("title");
      } else {
        link = $this.attr("href");
      }
      if (tracking.NAVIGATION) {
        dataLayer.push({
          event: "gp-interaction",
          category: "Main Navigation",
          action: "Expand",
          label: link,
          "interaction-type": true
        });
      }
      resizeMenu();
    }
    if (window.innerWidth >= smallView) {
      $(".list-header-actions li:first-of-type").focusin(function() {
        $header
          .find(".is-active")
          .removeClass("is-active")
          .end()
          .find(".is-open")
          .removeClass("is-open")
          .attr("aria-expanded", "false")
          .end();
        $main.attr("style", null);
        $footer.css("transform", `translateY(0px)`);
        if ($(".nav-secondary")) {
          $(".nav-secondary").css("transform", `translateY(0px)`);
        }
        $('body').trigger('menu:closed');
      });
    }
    $('body').trigger('menu:active');
    e.preventDefault();
  });
});

const resizeMenu = () => {
  if (window.innerWidth >= smallView) {
    $navSubMenu.offset({ left: -1 });
  } else {
    if ($(".nav-secondary")) {
      $(".nav-secondary").css("transform", `translateY(0px)`);
    }
    $main.attr("style", null);
    $footer.css("transform", "translateY(0px)");
  }
};

$(window).resize(resizeMenu);

if (tracking.NAVIGATION) {
  $navMenu.on("click", "li a", function OpenMenu() {
    const pathname = window.location.pathname;
    const link = $(this).attr("href");
    dataLayer.push({
      event: "gp-interaction",
      category: "Main Navigation",
      action: "Click",
      label: `From: ${pathname} To: ${link}`,
      "interaction-type": true
    });
  });
  $navSubMenu.on("click", "li a", function OpenMenu() {
    const pathname = window.location.pathname;
    const link = $(this).attr("href");
    dataLayer.push({
      event: "gp-interaction",
      category: "Main Navigation",
      action: "Click",
      label: `From: ${pathname} To: ${link}`,
      "interaction-type": true
    });
  });
}

const $startDate = new Date(new Date().getFullYear(), 5, 1, 0, 0, 0).getTime();
const $endDate = new Date(new Date().getFullYear(), 5, 30, 23, 59, 0).getTime();
const $currentDate = new Date().getTime();
const $prideFlag = $('.pride-flag');

if ($startDate <= $currentDate && $currentDate <= $endDate) {
    $prideFlag.css('display', 'block');
}